import { customAlphabet } from 'nanoid';

export const generateId = (num=6) => {
    if (!num) {
        throw new Error('missing value');
    };

    if (typeof num !== 'number') {
        throw new Error('incorrect type');
    };

    const nanoid = customAlphabet('QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm1234567890', num);

    return nanoid();
};
